import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Deadlines from './pages/Deadlines';
import Tasks from './pages/Tasks';
import Calendar from './pages/Calendar';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import MonthlyClose from './pages/MonthlyClose';
import Conversiones from './pages/Conversiones';
import Tributario from './pages/Tributario';
import TributarioDeclaracion from './pages/TributarioDeclaracion';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:clientId" element={<ClientDetail />} />
            <Route path="deadlines" element={<Deadlines />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="seguimiento" element={<MonthlyClose />} />
            <Route path="conversiones" element={<Conversiones />} />
            <Route path="tributario" element={<Tributario />} />
            <Route path="tributario/:declId" element={<TributarioDeclaracion />} />
            <Route path="users" element={<Users />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
